import { render, staticRenderFns } from "./OnProgresTexte.vue?vue&type=template&id=47535d23&"
import script from "./OnProgresTexte.vue?vue&type=script&lang=js&"
export * from "./OnProgresTexte.vue?vue&type=script&lang=js&"
import style0 from "./OnProgresTexte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports